module.exports = __webpack_public_path__ + "h5/img/noavatar.5eb87db1.png";